import { Modal, VerticalContainer } from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type SpellCheckInstructionViewProps = {
    onClose: () => void;
};
export const SpellCheckInstructionView = ({
    onClose,
}: SpellCheckInstructionViewProps) => {
    return (
        <Modal title={<h2>{R.SpellCheckModalTitle}</h2>} onClose={onClose}>
            <VerticalContainer>
                <span className="font-normal">{R.SpellCheckGuide}</span>
                <h4>{R.SpellCheckStep1Title}</h4>
                <span className="font-normal">
                    {R.SpellCheckStep1Description}
                </span>
                <h4>{R.SpellCheckStep2Title}</h4>
                <span className="font-normal">
                    {R.SpellCheckStep2Description}
                </span>
                <h4>{R.SpellCheckStep3Title}</h4>
                <span className="font-normal">
                    {R.SpellCheckStep3Description}
                </span>
            </VerticalContainer>
        </Modal>
    );
};
